"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { usePathname, useRouter } from "next/navigation";
import { useClerk } from "@clerk/nextjs";
import { LogIn, LogOut } from "lucide-react";
export const SignOutBtn = () => {
  const $ = _c(7);
  const {
    signOut
  } = useClerk();
  const router = useRouter();
  let t0;
  if ($[0] !== router || $[1] !== signOut) {
    t0 = () => signOut().finally(() => router.refresh());
    $[0] = router;
    $[1] = signOut;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LogOut size={16} />;
    t2 = <span>Đăng xuất</span>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t0) {
    t3 = <button onMouseDown={t0} className="flex w-full items-center gap-2 rounded px-2 py-1.5">{t1}{t2}</button>;
    $[5] = t0;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export const SignInBtn = () => {
  const $ = _c(5);
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = {
      pathname: "/auth/sign-in",
      query: {
        redirect_url: pathname
      }
    };
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LogIn size={16} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0) {
    t2 = <Link href={t0} className="flex w-full items-center gap-2 px-2 py-1.5">{t1}Đăng nhập</Link>;
    $[3] = t0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};